import React, { useState, useEffect } from 'react';
import { object, func, bool } from 'prop-types';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject } from '../../../utils/helpers';
import { isNull } from '../../../utils/validator';
import { getDateToString } from '../../../utils/convert';
import { ALERT_TYPE, ShowToastMessage } from '@laramie/ui';
import { useEntidad } from '../../hooks/useEntidad';
import ModeloDeclaracionJuradaEmisionDefinicionModal from '../ModeloDeclaracionJuradaEmisionDefinicionModal';

const ModeloDeclaracionJuradaEmisionDefinicionGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      idModeloDeclaracionJurada: 0,
      disabled: false,
      showMessage: false,
      showForm: false,
      mode: '',
      rowForm: null,
      list: []
  });

  const [rangoSolapado, setRangoSolapado] = useState(null);

  const mount = () => {
    setState(prevState => {
        const list = props.data.list.sort((a, b) => isNull(a.fechaDesde) ? 1 : isNull(b.fechaDesde) ? -1 : b.fechaDesde.getTime() - a.fechaDesde.getTime());
        return {...prevState,
          idModeloDeclaracionJurada: props.data.idModeloDeclaracionJurada,
          list: list
        };
    });
  }
  useEffect(mount, [props.data]);

  const [, geRowEntidad, readyEntidad] = useEntidad({
    entidades: ['EmisionDefinicion'],
    onLoaded: (entidades, isSuccess, error) => {
      if (!isSuccess) {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
      }
    },
    memo: null
  });

  function getEmisionDefinicion(idEmisionDefinicion) {
    const row = geRowEntidad('EmisionDefinicion', idEmisionDefinicion);
    return !isNull(row) ? `${row.descripcion} (${row.periodo})` : '';
  }

  const tableColumns = [
    { Header: 'Desde', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaDesde', width: '20%' },
    { Header: 'Hasta', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaHasta', width: '20%' },
    { Header: 'Definición de emisión', Cell: (props) => getEmisionDefinicion(props.value), accessor: 'idEmisionDefinicion', width: '50%' },
  ];

  //handles
  const avmr = {
    onAdd: props.disabled ? null : () => {
      setState(prevState => {
        const rowForm = {
          idModeloDeclaracionJurada: state.idModeloDeclaracionJurada,
          idEmisionDefinicion: 0,
          fechaDesde: null,
          fechaHasta: null
        };
        return {...prevState, showForm: true, mode: 'add', rowForm: rowForm};
      });
    },
    onRemove: props.disabled ? null : (row) => {
      setState(prevState => {
        return {...prevState, showMessage: true, rowForm: row};
      });
    },
  }

  //funciones
  function RemoveVinculo(row) {
    row.state = 'r';
    props.onChange(row);
  }

  function UpdateVinculo(row) {
    if (state.mode === 'modify')  {
      //para modificar aplico un unbind por el original, y un bind por el nuevo
      const rowToDelete = CloneObject(state.rowForm);
      RemoveVinculo(rowToDelete);
    }
    row.state = 'a';
    props.onChange(row);
  }

  function ValidateVinculo(row) {
    const listOthers = state.list.filter(
        (f) => f.idModeloDeclaracionJurada === row.idModeloDeclaracionJurada && f.idEmisionDefinicion !== row.idEmisionDefinicion
    );
    const conflicts = listOthers.filter(f =>
      (f.fechaDesde <= row.fechaHasta || isNull(f.fechaDesde) || isNull(row.fechaHasta)) &&
      (f.fechaHasta >= row.fechaDesde || isNull(f.fechaHasta) || isNull(row.fechaDesde))
    );
    return (conflicts.length === 0);
  }

  return (
  <>

    {state.showMessage && 
        <MessageModal
            title={"Confirmación"}
            message={"¿Está seguro/a de borrar el registro?"}
            onDismiss={() => {
                setState(prevState => {
                    return {...prevState, showMessage: false, rowForm: null};
                });
            }}
            onConfirm={() => {
                const row = CloneObject(state.rowForm);
                setState(prevState => {
                    return {...prevState, showMessage: false, rowForm: null};
                });
                RemoveVinculo(row);
            }}
        />
    }

    {state.showForm && 
        <ModeloDeclaracionJuradaEmisionDefinicionModal
            disabled={state.mode === ''}
            data={{
              entity: state.rowForm
            }}
            rangoSolapado={rangoSolapado}
            onDismiss={() => {
              setRangoSolapado(null);
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
            }}
            onConfirm={(row) => {
              if (ValidateVinculo(row)) {
                setRangoSolapado(null);
                UpdateVinculo(row);
                setState(prevState => {
                    return {...prevState, showForm: false, rowForm: null};
                });
              }
              else {
                setRangoSolapado({idEmisionDefinicion: row.idEmisionDefinicion, fechaDesde: row.fechaDesde, fechaHasta: row.fechaHasta});
              }
            }}
        />
    }

    <TableCustom
        showFilterGlobal={false}
        showDownloadCSV={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.list}
        avmr={avmr}
        editCode="modelo-declaracion-jurada_edit"
    />

  </>
  );
}

ModeloDeclaracionJuradaEmisionDefinicionGrid.propTypes = {
    disabled: bool,
    data: object.isRequired,
    onChange: func.isRequired
};

ModeloDeclaracionJuradaEmisionDefinicionGrid.defaultProps = {
    disabled: false
  };

export default ModeloDeclaracionJuradaEmisionDefinicionGrid;